import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import { ensureReportAuth } from './core/reportAuth'
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import 'firebase/storage'; 
export default {
  namespaced: true,
  state: {
        user:{},
        period:'',
        recognitionGem:[],
        overall_value:{goal_value:0,culture_value:0,overall_value:0},
        month:[],
        data_month_year:[{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'},{goal:'gray',culture:'gray'}],
        radar_Chart:{label:[],hash:{}},
        text_performance:'',
        text_recognition:'',
        text_peerfeedback:'',
        dataAI:{},
        loading:true,
        status_loading:false
  },
  mutations: {
    setRecognitionGem(state:any, value:any){
      state.recognitionGem = value
    },
    setOverallvalue(state:any, value:any){
      state.overall_value = value
    },
    setMonth(state:any, value:any){
      state.month = value
    },
    setDataMonthYear(state:any, value:any){
      state.data_month_year = value
    },
    setUser(state:any, value:any){
      state.user = value
    },
    setperiod(state:any, value:any){
      state.period = value
    },
    setradarChart(state:any, value:any){
      state.radar_Chart = value
    },
    settext_performance(state:any, value:any){
      state.text_performance = value
    },
    settext_recognition(state:any, value:any){
      state.text_recognition = value
    },
    settext_peerfeedback(state:any, value:any){
      state.text_peerfeedback = value
    },
    setDataAI(state:any, value:any){
      state.dataAI = value
    },
    setLoading(state:any, value:any){
      state.loading = value
    },
    setStatusLoading(state:any, value:any){
      state.status_loading = value
    }

  },
  actions: {
    async login({commit,state}:any, obj:any){
        
        console.log('No user is signed in.')
        await ensureReportAuth()
    },
    async getuser({ commit, dispatch, rootState, state }: any, user: any) {
        const emailKey=user.replace(/\./g, '||')
        const userData=await (await firebase.database().ref(`users/${emailKey}`).once('value')).val()
        if(userData){
            const teamData=(await firebase.database().ref('team').orderByChild("company").equalTo(userData.company).once('value')).val()
            const companyData=(await firebase.database().ref(`company/${userData.company}`).once('value')).val()
            const data={
                name:userData.firstname+' '+userData.lastname,
                team_name:teamData[userData.team].name,
                image:userData.profilepic_crop,
                company_name:companyData.name,
                firstname:userData.firstname,
            }
            dispatch('getradarChart',userData)
            commit('setUser',data)
        }
       

    },
    async getActivityTimeline({ commit, dispatch, rootState, state }: any, user: any) {
      const past12Month=format(addMonths(new Date(), -12), 'YYYY-MM-DD')
      
      
      const goal={
        '4':'Exceeded',
        '3':'Met',
        '2':'Partially',
        '1':'Did not Meet'
      }
      const culture={
        '4':'Significantly',
        '3':'Consistently',
        '2':'Somewhat',
        '1':'Rarely'
      }
      let text_performance=''
      
      let recognitionGem:any= []
      let color:any= ''
      let goal_value:any= 0
      let culture_value:any= 0
      let total:any= 0
      let image:any= ''
      const data_month:any=[]
      firebase.firestore().collection('send_review_gem').where('receiver', '==', user).where('createdate', '>=', past12Month).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let performance="{Date Time}\n{Goal Rating}: \"{Goal Feedback}\"\n{Culture Rating}: \"{Culture Feedback}\"\n\n"
          const data = doc.data()
          const _month_year=format(new Date(data.createdate), 'YYYY-MM')
          if(!data_month[_month_year]){
            data_month[_month_year]=data
          }
          
          if((data.goal==4||data.goal==3)&&(data.culture==4||data.culture==3)){
            color='pink'
            image='https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74'
          }else{
            color='gray'
            image='https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0'
          }


          recognitionGem.push({
            image:image,
            date: format(new Date(data.createdate), 'MMMM YYYY'),
            createdate:data.createdate,
            goal:goal[data.goal],
            goal_value:data.goal_value,
            culture:culture[data.culture],
            culture_value:data.culture_value,
            color:color
          })
          total++
          if(data.goal==4||data.goal==3){
            goal_value+=1
          }else if(data.goal==2){
            goal_value+=0.5
          }
          if(data.culture==4||data.culture==3){
            culture_value+=1
          }else if(data.culture==2){
            culture_value+=0.5
          }
          const date_performance=data.createdate
          performance=performance.replace("{Date Time}",date_performance)
          if(data.goal&&data.goal_value){
            performance=performance.replace("{Goal Rating}",goal[data.goal])
            performance=performance.replace("{Goal Feedback}",data.goal_value)
          }
          if(data.culture&&data.culture_value){
            performance=performance.replace("{Culture Rating}",culture[data.culture])
            performance=performance.replace("{Culture Feedback}",data.culture_value)
          }
          text_performance=text_performance+performance

        })
       
        goal_value=isNaN((goal_value*100)/total)?0:((goal_value*100)/total).toFixed()
        culture_value=isNaN((culture_value*100)/total)?0:((culture_value*100)/total).toFixed()
        const overall_value=isNaN((goal_value+culture_value)/2)?0:((Number(goal_value)+Number(culture_value))/2).toFixed()
        commit('setOverallvalue',{goal_value:goal_value,culture_value:culture_value,overall_value:overall_value})
        commit('settext_performance',text_performance)
        
        const old_performance=sessionStorage.getItem("performance")?sessionStorage.getItem("performance"):''
        if(old_performance!=text_performance||old_performance==""){
          sessionStorage.setItem("performance", text_performance);
          commit('setStatusLoading',true)
        }
        recognitionGem=_.orderBy(recognitionGem, function(dateObj) {
            return new Date(dateObj.createdate);
          },['desc'])



          const month:any=[]
          const month_year:any=[]
          const data_month_year:any=[]
          let _goal=''
          let _culture=''
          
          let gem:any=''
          for(let i=11;i>=0;i--){
            month.push(format(addMonths(new Date(), -i), 'MMM'))
            month_year.push(format(addMonths(new Date(), -i), 'MMM YYYY'))
            
            if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')]){
                
                if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].goal==4){
                    _goal='green'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].goal==3){
                    _goal='light-green'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].goal==2){
                    _goal='yellow'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].goal==1){
                    _goal='red'
                }
                if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].culture==4){
                    _culture='green'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].culture==3){
                    _culture='light-green'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].culture==2){
                    _culture='yellow'
                }else if(data_month[format(addMonths(new Date(), -i), 'YYYY-MM')].culture==1){
                    _culture='red'
                }
                if((_goal=='green'||_goal=='light-green')&&(_culture=='green'||_culture=='light-green')){
                    gem=true
                }else{
                    gem=false
                }
                data_month_year.push({goal:_goal,culture:_culture,gem:gem})
            }else{
                data_month_year.push({goal:'gray',culture:'gray',gem:false})
            }
           
            // // data_month[month_year[i]]=month[i]
          }
          commit('setperiod',`${format(addMonths(new Date(), -11), 'MMM YYYY')} - ${format(new Date(), 'MMM YYYY')}` )
          commit('setDataMonthYear',data_month_year)
          commit('setMonth',month)
          commit('setRecognitionGem',recognitionGem)
          
      })
    },
    async getradarChart({ commit, dispatch, rootState, state }: any, user: any) {
      let text_recognition=''
      let text_peerfeedback=''
      const past12Month=format(addMonths(new Date(), -12), 'YYYY-MM-01')
      const promise1=new Promise((resolve,reject)=>{
        const sender:any=[]
        firebase.firestore().collection('here_point').where('sender_email', '==', user.email).where('statusrow', '==', 'sendcoin').where('date', '>=', past12Month).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            sender.push(data)
            //console.log('eeee',data)
               
          })
          resolve(sender)
        })

      })

      const promise2=new Promise((resolve,reject)=>{
        const send_to:any=[]
        
        firebase.firestore().collection('here_point').where('send_to_email', '==', user.email).where('statusrow', '==', 'sendcoin').where('date', '>=', past12Month).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            let recognition='{Date Time}: \"{Recognition}\", {value hashtags}\n'
            send_to.push(data)
            const date_recognition=data.date
            let hashtag=''
            if(data.hashtag){
              for(const i in data.hashtag){
                const item=data.hashtag[i]
                hashtag=hashtag+" "+item
              }
            }
            
            recognition=recognition.replace('{Date Time}',date_recognition)
            recognition=recognition.replace('{Recognition}',data.reason)
            if(hashtag==""){
              recognition=recognition.replace(', {value hashtags}',hashtag)
            }else{
              recognition=recognition.replace('{value hashtags}',hashtag)
            }
            
            text_recognition+=recognition+"\n"
          })
          //console.log('text_recognition',text_recognition)
          resolve(send_to)
        })

      })
      
      const promise3=new Promise((resolve,reject)=>{  
       
        let text_peerfeedback=''
        let excel_text:any=''
        let improves_text=''
        firebase.firestore().collection('peerfeedback').where('email_to', '==', user.email).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            
            if(format(new Date(data.createdate), 'YYYY-MM-DD')>=past12Month){
              // console.log('data',data)
              const date_peerfeedback=data.createdate
              excel_text=''
              if(data.excels){
                
                for(const i in data.excels){
                  let excel:string='Excels at:\n{Skill}: {Comma separated attributes selected}, {feedback}\n'
                  const item=data.excels[i]
                  
                  let selecte:string=''
                  for(const j in item.selected){
                    
                    if(item.selected.length==(Number(j)+1)){
                       selecte=selecte+item.selected[j].text_en
                    }else{
                       selecte=selecte+item.selected[j].text_en+', '
                    }
 
                  }
                  excel=excel.replace("{Comma separated attributes selected}",selecte)
                  excel=excel.replace("{feedback}",item.detail)
                  excel=excel.replace("{Skill}",item.name)
                  excel_text=excel_text+excel
                  //console.log('excel',excel)
           
                }
                
              }
              improves_text=''
              if(data.improves){
                for(const i in data.improves){
                  let improves:string='Can Improve at:\n{Skill}: {Comma separated attributes selected}, {feedback}\n'
                  const item=data.improves[i]
                  
                  let selecte:string=''
                  for(const j in item.selected){
                    
                    if(item.selected.length==(Number(j)+1)){
                       selecte=selecte+item.selected[j].text_en
                    }else{
                       selecte=selecte+item.selected[j].text_en+', '
                    }
 
                  }
                  improves=improves.replace("{Comma separated attributes selected}",selecte)
                  improves=improves.replace("{feedback}",item.detail)
                  improves=improves.replace("{Skill}",item.name)
                  improves_text=improves_text+improves
           
                }




              }
              let suggest=''
              if(data.suggest){
                suggest=data.suggest.line1_en+" "+data.suggest.line2_en
              }
              let suggest_detail=''
              if(data.suggest_detail){
                suggest_detail=data.suggest_detail
              }
              text_peerfeedback+=date_peerfeedback+"\n"+excel_text+"\n"+improves_text+"\n"+suggest+": "+suggest_detail+"\n\n"
              
            }
            
          })
          resolve(text_peerfeedback)
          //console.log('text_peerfeedback',text_peerfeedback)
        })
      })
     
      Promise.all([promise1,promise2,promise3]).then((res)=>{
        const sender_data=res[0]
        const send_to_data=res[1]
        const text_peerfeedback:any=res[2]
        const text_peerfeedback_string=text_peerfeedback.toString()
        
        let data:any=[]
        const label:any=[]
        data=_.concat(sender_data,send_to_data)
        ///console.log('data',data)
        const hash:any={}
        

        //get label
        for(const i in data){
          const item=data[i]
          
          if(item.hashtag&&item.hashtag.length>0){
            for(const j in item.hashtag){
              const check_label=_.find(label,(item_label:any)=>item_label==item.hashtag[j])
              if(!check_label){
                label.push(item.hashtag[j])
              }
              if(!hash[item.hashtag[j]]){
                hash[item.hashtag[j]]={given:0,received:0}
              }
              if(item.sender_email==user.email){
                hash[item.hashtag[j]].given+=1
              }else{
                hash[item.hashtag[j]].received+=1
              }
              
            }

            
          }


        }
     
        commit('settext_recognition',text_recognition)
        const old_recognition=sessionStorage.getItem("recognition")?sessionStorage.getItem("recognition"):''
        if(old_recognition!=text_recognition||old_recognition==""){
         
          sessionStorage.setItem("recognition", text_recognition);
          commit('setStatusLoading',true)
        }
        
      
        commit('settext_peerfeedback',text_peerfeedback)
        const old_peerfeedback=sessionStorage.getItem("peerfeedback")?sessionStorage.getItem("peerfeedback"):''
        if(old_peerfeedback!=text_peerfeedback_string||old_peerfeedback==""){
         
          sessionStorage.setItem("peerfeedback", text_peerfeedback_string);
          commit('setStatusLoading',true)
        }
 
        commit('setradarChart',{hash:hash,label:label})
        if(state.status_loading){
              dispatch('getperformanceSummaryReport',user)
        }else{
            const json_string:any=sessionStorage.getItem("performance_summary_report")?sessionStorage.getItem("performance_summary_report"):''
            if(json_string==''){
              dispatch('getperformanceSummaryReport',user)
            }else{
              console.log('catch')
              const message = JSON.parse(json_string);
              if(message){
                      commit('setDataAI',message)
                      sessionStorage.setItem("performance_summary_report", json_string);
                      commit('setLoading',false)
              }

            }
          
        }
        
      })
      

    },
    async getperformanceSummaryReport({ commit, dispatch, rootState, state }: any, user: any) {
      const peerfeedback=state.text_peerfeedback
      const recognition=state.text_recognition
      const performance=state.text_performance
      var axios = require('axios');
      const url=`https://api-node.happily.ai/openai/get_performance_summary_report`
      //const url=`http://localhost:80/openai/get_performance_summary_report`
      const config = {
          method: 'post',
          url: url,
          data: {
            peerfeedback: peerfeedback,
            recognition: recognition,
            performance: performance,
          },
          headers: {
              'Content-Type': 'application/json'
          }
      };
      const response = await axios(config)
      const json = response.data;
      //if(json && json.choices && json.choices[0] && json.choices[0].message && json.choices[0].message.content){
      //   const fixedJsonString =json.choices[0].message.content;
      //   const json_string=fixedJsonString.replace('```json\n','').replace('\n```','')
        let message;
        try {
                message =json

                //console.log('message',message)
                if(message){
                  commit('setDataAI',message)
                  sessionStorage.setItem("performance_summary_report", json);
                  commit('setLoading',false)
                }
        } catch (error) {
            message = false;
        }
      //}
    }
  },
  getters: {
    recognitionGem(state:any){
      return state.recognitionGem
    },
    overall_value(state:any){
      return state.overall_value
    },
    month(state:any){
      return state.month
    },
    data_month_year(state:any){
      return state.data_month_year
    },
    user(state:any){
      return state.user
    },
    period(state:any){
      return state.period
    },
    radar_Chart(state:any){
      return state.radar_Chart
    },
    dataAI(state:any){
      return state.dataAI
    },
    loading(state:any){
      return state.loading
    }

  }
}